import {
  FAQ_CREATE,
  FAQ_ERROR_RESPONSE,
  FAQ_REQUEST,
  FAQ_RESPONSE,
  FAQ_SAVE_REQUEST,
  FAQ_SAVE_RESPONSE,
  FAQ_SAVE_ERROR_RESPONSE,
  FAQ_SETTINGS_FINISH_EDIT,
  FAQ_REMOVE_REQUEST,
  FAQ_REMOVE_RESPONSE,
  FAQ_REMOVE_ERROR_RESPONSE,
  FAQ_ADD_QUESTION,
  FAQ_DELETE_QUESTION,
} from 'constants/action_names';
import text from 'constants/text';
import { createFaqQuestion } from 'constants/faq';

const initialState = {
  faq: [],
  _loading: false, // Faqs we are loading
  _loaded: false, // Faqs we have tried to load
  removing: false,
  saving: false,
  resetToInitial: false,
  errors: [],
};

export const deleteFaq = (faq, questionId) => ({
  ...faq,
  content: faq.content.filter(c => c?.id !== questionId),
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FAQ_ADD_QUESTION:
      return {
        ...state,
        faq: state.faq.map(faq => {
          if (faq.id === action.faqId) {
            const newFaq = action.faq || createFaqQuestion(faq.content.length);
            return {
              ...faq,
              content: [...faq.content, newFaq],
            };
          }
          return faq;
        }),
      };
    case FAQ_DELETE_QUESTION:
      return {
        ...state,
        faq: state.faq.map(faq => {
          if (faq.id === action.faqId) {
            const withoutNode = deleteFaq(faq, action.questionId);
            return withoutNode;
          }
          return faq;
        }),
      };
    case FAQ_CREATE:
      return {
        ...state,
        faq: [...state.faq, action.newFaq],
      };
    case FAQ_REQUEST:
      return {
        ...state,
        errors: [],
        _loading: true,
        _loaded: false,
      };
    case FAQ_RESPONSE:
      return {
        ...state,
        faq: [...state.faq, ...action.json],
        errors: [],
        _loading: false,
        _loaded: true,
      };
    case FAQ_ERROR_RESPONSE:
      return {
        ...state,
        errors: [
          {
            title: 'Failed to fetch faq',
            details: 'Try again later',
            type: 'fetch',
          },
        ],
        _loading: false,
        _loaded: false,
      };
    case FAQ_SAVE_REQUEST:
      return {
        ...state,
        errors: [],
        saving: true,
      };
    case FAQ_SAVE_RESPONSE:
      return {
        ...state,
        errors: [],
        saving: false,
      };
    case FAQ_SAVE_ERROR_RESPONSE:
      return {
        ...state,
        saving: false,
        errors: [
          {
            // TODO replace text
            title: text.errors.folderSave.title,
            details: text.errors.folderSave.details,
            type: 'save',
          },
        ],
      };
    case FAQ_REMOVE_REQUEST:
      return {
        ...state,
        removing: true,
        errors: [],
      };
    case FAQ_REMOVE_RESPONSE:
      return {
        ...state,
        errors: [],
        faq: state.faq.filter(faq => faq.id !== action.faqId),
        removing: false,
      };
    case FAQ_REMOVE_ERROR_RESPONSE:
      return {
        ...state,
        removing: false,
        errors: [
          {
            // TODO replace text
            title: text.errors.folderRemove.title,
            details: text.errors.folderRemove.details,
            type: 'remove',
          },
        ],
      };
    case FAQ_SETTINGS_FINISH_EDIT: {
      return {
        ...state,
        faq: state.faq.map(faq => {
          if (faq.id === action.faq.id) {
            return {
              ...action.faq,
            };
          }
          return faq;
        }),
      };
    }
    default:
      return state;
  }
};

export default reducer;
